<template>
  <div class="mt-4">
    <grid
      ref="grid"
      :list-url="trainersListUrl || listUrl"
      :new-header-action-emit="true"
      :edit-action-as-link="false"
      @header-action="onGridHeaderAction"
      @item-action="onGridItemAction"
    />
    <teleport
      to="#vue-portal-target"
      append
    >
      <candidate-modal
        ref="trainerModal"
        :type-id="2"
        :modal-title="trainerModalTitle"
        @success="trainerModalSuccess"
      />
    </teleport>
  </div>
</template>
<script setup lang="ts">
import {nextTick, ref, useTemplateRef} from 'vue'
import Grid from './grid.vue'
import CandidateModal from './candidate-modal.vue'

import type {ButtonAction, GridHeaderAction, GridItem, ItemAction} from './types'
import {isNonEmptyString} from '../js-utils'

defineProps({
  listUrl: {type: String, default: null}
})

const grid = useTemplateRef("grid")
const trainerModal = useTemplateRef("trainerModal")

const trainersListUrl = ref<string | null>(null)
const trainerModalTitle = ref("")

const onGridHeaderAction = (actionOrName: string | GridHeaderAction | ButtonAction): void => {
  if (typeof actionOrName === 'string') {
    return
  }

  const action = actionOrName
  if (action.name == 'new-trainer') {
    trainerModalTitle.value = 'Add trainer'
    if (isNonEmptyString(action.url)) {
      trainerModal.value?.showModal(action.url, null)
    }
  }
}

const onGridItemAction = (item: GridItem, action: ItemAction): void => {
  if (action.name == 'edit') {
    const editLink = item.links?.edit_form
    if (isNonEmptyString(editLink)) {
      trainerModalTitle.value = 'Edit trainer'
      trainerModal.value?.showModal(editLink, null)
    }
  }
}

const trainerModalSuccess = (): void => {
  trainerModal.value?.hideModal()
  grid.value?.reload()
}

const fetchContent = (data: any): void => {
  if (data && isNonEmptyString(data.listUrl)) {
    trainersListUrl.value = data.listUrl
  } else {
    trainersListUrl.value = null
  }

  nextTick(() => {
    grid.value?.reload()
  })
}

defineExpose({
  fetchContent,
})
</script>
